export default [
  {
    path: '/student-management',
    name: 'studentManagement',
    component: () => import('@/views/StudentManagement/index.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
    },
  },
  {
    path: '/student-management/statistics',
    name: 'statistics',
    component: () => import('@/views/StudentManagement/StatisticsDetail.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
];
